.DateExpandedInner
    width: 100%
    margin: 0
    padding: 15px
    box-sizing: border-box
    .Item
        padding: 7px 11px
        &:hover
            background: rgb($globalSettingsBackgroundTertiary)
            font-weight: 700
